import { CommissionInput } from 'types/comission'
import { DiscountType } from 'types/discount'
import {
    Order,
    OrderApiOutput,
    OrderPayment,
    OrderPaymentApiOutput,
    OrderType,
} from 'types/order'
import { postApiRequest } from 'utils/fetch-helper'

export type OrderInputOptions = {
    commission?: CommissionInput
    adhocDiscount?: number
    adhocDiscountType?: DiscountType
    couponCode?: string
    couponId?: string
    fullyPaid?: boolean
}
export type CreateOrderApiOutput = {
    id: string
    clientId: string
    quantity: number
    soldBy: string
    taxOverride: number
    type: OrderType
    message?: string
}
export async function createOrder(
    clientEmail: string,
    clientFirstName: string,
    clientLastName: string,
    clientPhone: string,
    tenantId: string,
    type: OrderType = OrderType.SERVICE,
    order_options?: OrderInputOptions
): Promise<CreateOrderApiOutput> {
    return await postApiRequest('/v1/orders', {
        ...order_options,
        clientEmail,
        clientFirstName,
        clientLastName,
        clientPhone,
        tenantId,
        type,
    })
}
export function denormalizeOrder(order: OrderApiOutput): Order {
    const payments: OrderPayment[] = order.payments.map(
        (p: OrderPaymentApiOutput) => ({
            ...p,
            location_id: p.locationId,
            payment_integration: {
                id: p.paymentIntegrationId,
            },
            payment_method: p.paymentMethod,
        })
    )

    return {
        id: order.id,
        coupon: {
            id: order.couponId as string,
            code: order?.couponCode as string
        },
        discount: {
            amount: order.adhocDiscount || 0,
            type:
                (order.adhocDiscountType as unknown as DiscountType) ||
                DiscountType.PERCENT,
        },
        fully_paid: order.fullyPaid,
        payments,
        membership_client_id: order.membershipClientId,
        total_amount: order.totalAmount
    }
}

export function denormalizeOrders(orders: OrderApiOutput[]): Order[] {
    return orders.map(denormalizeOrder)
}
